import React from 'react';

export default function OnBilgilendirmeFormu() {
    return (
        <div className="max-w-3xl mx-auto py-12 px-4">
            <h1 className="font-display text-3xl text-[var(--ink)] mb-4">Ön Bilgilendirme Formu</h1>
            <p className="text-[var(--muted)] text-sm">Bu belge yakında eklenecektir.</p>
        </div>
    );
}
